const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      slider: '.lyt-content-slide-01',
      box: '.js-slider-box',
    };

    $(document).ready(() => {
      // Disable temporarily and decide later whether to refactor it or remove it and use carousel-slider.js
      // this.init();
    });
  }

  init() {
    this.destroyOldSlider();
    this.initSlider();
  }

  destroyOldSlider() {
    $(this.selectors.slider).slick('unslick');
  }

  initSlider() {
    const $slider = $(this.selectors.slider);

    $slider.on('init', () => {
      const color = $slider.parents('.has-background').css('background-color');
      if (color) {
        $slider.find(this.selectors.box).css('background-color', color);
      }
    });

    $slider.slick({
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 660,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
      ],
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/logos-slider.js